import { FC } from 'react'
import { Button, Space, Tag } from 'antd'
import Contractor, { ApprovalStatus } from '../../../../../types/api/contractor'
import { useUpdateContractorMutation } from '../../../../../store/api/contractors-api'
import { useAppSelector } from '../../../../../store/store'
import { BusinessRole } from '../../../../../types/api/user'
import useErrorModal from '../../../../../hooks/api/use-error-modal'
import useSuccessModal from '../../../../../hooks/api/use-success-modal'

interface ApprovalStatusCellProps {
    contractor: Contractor
}

const ApprovalStatusCell: FC<ApprovalStatusCellProps> = ({ contractor }) => {
    const [updateContractor, updateContractorState] = useUpdateContractorMutation()
    const user = useAppSelector(state => state.auth.user)
    const isLogist = user?.businessRoles?.includes(BusinessRole.Logist)
    const isDraft = contractor.approvalStatus === 'draft' || !contractor.approvalStatus

    useErrorModal(updateContractorState, 'Не удалось подтвердить клиента')
    useSuccessModal(updateContractorState, 'Клиент подтвержден')

    const handleApprove = () => {
        updateContractor({
            docId: contractor.documentId,
            body: {
                data: {
                    approvalStatus: 'approved' as ApprovalStatus,
                },
            },
        })
    }

    const status = (contractor.approvalStatus || 'draft') as ApprovalStatus

    const statusTextMap: Record<ApprovalStatus, string> = {
        draft: 'Черновик',
        approved: 'Подтвержден',
    }

    const statusColor = status === 'approved' ? 'green' : 'orange'

    return (
        <Space size='small' style={{ display: 'flex', justifyContent: 'center' }}>
            <Tag color={statusColor} style={{ margin: 0 }}>
                {statusTextMap[status]}
            </Tag>
            {isDraft && isLogist && (
                <Button
                    type='primary'
                    size='small'
                    loading={updateContractorState.isLoading}
                    onClick={handleApprove}
                    style={{ fontSize: '11px', padding: '0 8px', height: '22px' }}
                >
                    Подтвердить
                </Button>
            )}
        </Space>
    )
}

export default ApprovalStatusCell
